import { render, staticRenderFns } from "./button.vue?vue&type=template&id=3716135e&scoped=true"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"
import style0 from "./button.vue?vue&type=style&index=0&id=3716135e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3716135e",
  null
  
)

export default component.exports